"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("@angular/router");
const app_component_1 = require("./app.component");
const vasat_1 = require("vasat");
class LoginNeeded {
    constructor(V, r) {
        this.V = V;
        this.r = r;
    }
    canActivate(route, state) {
        if (this.V.localSession())
            return true;
        else {
            this.r.navigate(['/auth'], { queryParams: { prevpage: state.url, msg: 'Login Timed out' } });
            return false;
        }
    }
}
exports.LoginNeeded = LoginNeeded;
let currentTeam = 'test';
const Routes = [
    { path: '', redirectTo: currentTeam, pathMatch: 'full' },
    { path: ':team', component: app_component_1.AppBaseComponent,
        children: [
            { path: '**', component: app_component_1.HomeComponent },
        ]
    }
];
class Ver5Module {
}
exports.Ver5Module = Ver5Module;
